import { helpers } from 'vuelidate/lib/validators'

const stringContainsNumberOnly = /^[0-9]+/g
export const removeNumberExtraCharacters = value => {
  return value.match(stringContainsNumberOnly)
    ? Number(value.match(stringContainsNumberOnly)[0])
    : 0
}

const eitherEnglishNorChinese = /(?![a-zA-Z\s\u4e00-\u9eff\b]+)/g
export const englishOrChineseCharactersOnly = value =>
  !helpers.req(value) || !(value.match(eitherEnglishNorChinese).length > 1)

const eitherNumberNorSomeCharacters = /(?![0-9 || \b\-(),#ext._/]+)/g
export const phoneIncludeSomeCharactersOnly = value =>
  !helpers.req(value) ||
  !(value.match(eitherNumberNorSomeCharacters).length > 1)

const noChineseCharacters = /[\u4e00-\u9eff]+/g

export const englishOrCharactersOnly = value =>
  !helpers.req(value) || !value.match(noChineseCharacters)
